import React, { FC, ReactNode, Suspense } from 'react'
import PrivateRoute from './privateRoute'
import SuspendFallbackLoading from '@src/components/fallback-loading'

export interface WrapperRouteProps {
	/** document title id */
	titleId: string
	/** authorization？ */
	auth?: boolean
	/** 页面内容（React 节点） */
	children: ReactNode
}

const PublicRoute = ({ children }: { children: ReactNode }) => {
	return <>{children}</>
}

// config.tsx
export const WrapperRouteComponent: FC<WrapperRouteProps> = ({ titleId, auth, children }) => {
	if (titleId) {
		document.title = titleId
	}

	return auth ? (
		<PrivateRoute>{children}</PrivateRoute>
	) : (
		<Suspense fallback={<SuspendFallbackLoading message="正在加载中" />}>{children}</Suspense>
	)
}
export const WrapperRouteWithOutLayoutComponent: FC<WrapperRouteProps> = ({ titleId, children }) => {
	if (titleId) {
		document.title = titleId
	}

	return <Suspense fallback={<SuspendFallbackLoading message="正在加载中" />}>{children}</Suspense>
}
